import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { IApplicantData } from '../../../models/dashboard/jobs/singleJobApplicants.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';
import { useAppDisPatch } from '../../../redux/store';
import { addMatch } from '../../../redux/slices/interviewMatchSlice';

const useGetJobApplicantsForScreening = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [applicantData, setApplicantData] = useState<any>();

  const dispatch = useAppDisPatch();

  const onGetJobApplicantsForScreeningSuccess = useCallback(
    ({ data, message }: SuccessHttpResponse<IApplicantData[]>) => {
      const filteredData = data.filter(
        (applicant) => applicant.status === 'SCREENING'
      );
      console.log(filteredData);
      setApplicantData(filteredData);

      // Filter applicants with status 'INTERVIEW'
      const interviewApplicants = data.filter(
        (applicant) => applicant.status === 'INTERVIEW'
      );

      // Dispatch each applicant's email and userId to Redux
      interviewApplicants.forEach((applicant) => {
        dispatch(
          addMatch({
            email: applicant.email,
            userId: applicant.userId,
          })
        );
      });
    },
    [dispatch]
  );

  const onGetJobApplicantsForScreeningError = useCallback(
    (err: AxiosError<ErrorHttpResponse>) => {
      if (
        err.response?.status === 404 &&
        err.response?.data?.message === 'No application found'
      ) {
        onGetJobApplicantsForScreeningSuccess({
          status: 'success',
          data: [],
          message: 'No application found',
        });
        setLoading(false);
        return;
      }
      console.error(
        err?.message ?? 'Something went wrong while fetching jobs applicants'
      );
    },
    [onGetJobApplicantsForScreeningSuccess]
  );

  const getSingleJobApplicantForScreening = useCallback(
    (jobId: string) => {
      const url: HttpConfig = {
        url: `jobs-service/jobs/${jobId}/applicants`,
        method: 'get',
      };

      return request(
        url,
        onGetJobApplicantsForScreeningSuccess,
        setLoading,
        onGetJobApplicantsForScreeningError
      );
    },
    [
      request,
      onGetJobApplicantsForScreeningSuccess,
      onGetJobApplicantsForScreeningError,
    ]
  );

  return { getSingleJobApplicantForScreening, loading, applicantData };
};

export default useGetJobApplicantsForScreening;
